import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AlertDialogComponent} from '../shared-components/alert-dialog/alert-dialog.component';
import {ConfirmDialogComponent} from '../shared-components/confirm-dialog/confirm-dialog.component';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogsService {

  constructor(private dialog: MatDialog) {
  }

  alert(title: string, message1: string): any {
    return this.dialog.open(AlertDialogComponent, {
      data: { title, message: message1 }
    });
  }

  confirm(title: string, message1: string, preWrapMessage?: boolean): Observable<boolean> {
    return this.dialog.open(ConfirmDialogComponent, {
      data: { title, message: message1, preWrapMessage: preWrapMessage }
    }).afterClosed();

  }

}
